import API from '../../apiCreate'
import type { ResponseExternalWebhookCatalog } from './external-webhook.types'

export const externalWebhookApi = {
  /** GET /v1/external-webhook/catalog */
  getCatalog: () =>
    API.get<ResponseExternalWebhookCatalog>('external-webhook/catalog'),
}
